import { render, staticRenderFns } from "./ToWebAnnounceView.vue?vue&type=template&id=6fd09766&scoped=true&"
import script from "./ToWebAnnounceView.vue?vue&type=script&lang=js&"
export * from "./ToWebAnnounceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd09766",
  null
  
)

export default component.exports